import React, { useEffect, useState } from "react";
import { uploadNews, getNews, deleteNews } from "./ManageNewsAndUpdates";

const NewsManager = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pdf, setPdf] = useState(null);
  const [newsList, setNewsList] = useState([]);

  const fetchNews = async () => {
    try {
      const data = await getNews();
      setNewsList(data);
    } catch (error) {
      console.error("Failed to fetch news:", error);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleUpload = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("pdf", pdf);

    try {
      await uploadNews(formData);
      fetchNews();
      setTitle("");
      setDescription("");
      setPdf(null);
    } catch (error) {
      alert("Error uploading news.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this news?")) {
      await deleteNews(id);
      fetchNews();
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6  ">
      <h1 className="text-2xl font-bold text-center mb-4">News Management</h1>
      <form
        onSubmit={handleUpload}
        className="mb-6 p-4 bg-white rounded-lg shadow"
      >
        <h2 className="text-lg font-semibold mb-2">Upload News & Updates</h2>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full p-2 border rounded mb-2"
          required
        />
        <textarea
          placeholder="Link"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full p-2 border rounded mb-2"
        ></textarea>
        <label className="flex between space-x-2">
          <span className="text-sm font-medium">Attach PDF</span>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdf(e.target.files[0])}
            className="mb-2"
          />
        </label>
        <button
          type="submit"
          className="bg-teal-400 bg:hover-teal-500 text-white px-4 py-2 rounded"
        >
          Upload
        </button>
      </form>

      {/* News List */}
      <h2 className="text-lg font-semibold mb-2 ">News List</h2>
      {newsList.length === 0 ? (
        <p className="text-center">No news available.</p>
      ) : (
        <ul className="space-y-3">
          {newsList.map((item) => (
            <li
              key={item._id}
              className="p-4 bg-white rounded-lg shadow flex justify-between items-center"
            >
              <div>
                <h3 className="font-bold">{item.title}</h3>
                <p>{item.description}</p>
                <a
                  href={`https://collegebackend-e43r.onrender.com${item.pdf}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500"
                >
                  View PDF
                </a>
              </div>
              <button
                onClick={() => handleDelete(item._id)}
                className="bg-teal-400  text-white px-3 py-1 rounded"
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NewsManager;
